import BaseWorldScene, {GamePlayer, PlayerProfileInfo} from "../BaseWorldScene";
import {ChatMessage, LiveAppContext, OverlayMessage, PlayerAndInfo} from "../LiveWorldScene";
import Phaser from "phaser";
import {float} from "../stuff";
import VenueDefinition from "../VenueDefinition";
import {confappdata} from "confappdata";

type Sprite = Phaser.Physics.Arcade.Sprite;
type Collider = Phaser.Physics.Arcade.Collider;
type StaticGroup = Phaser.Physics.Arcade.StaticGroup;
type Tilemap = Phaser.Tilemaps.Tilemap;
type Shape = Phaser.GameObjects.Shape;

export class GamePlayerWithControls {
    constructor(
        public gamePlayer: GamePlayer,
        public touchTyping: () => void,
        public showTyping: () => void,
        public hideTyping: () => void
    ) {
    }
}

export enum TutorialPhase {
    MovingAround= 1,
    Chatting,
    TextChat,
    ChatFunctionShow,
    SendMessage,
    UserProfile
}

export default class TutorialWorldScene extends BaseWorldScene {
    tutorialPhase: TutorialPhase = TutorialPhase.MovingAround
    botX = 0
    boxY = 0
    botPlayer: GamePlayerWithControls | null = null
    wallParts: [StaticGroup, Collider] | null = null
    arrowX = 0
    arrowY = 0

    constructor(
        public worldKey: string,
        public mapKey: string,
        public backOnBounds: boolean,
        public appContext: LiveAppContext,
        venue: VenueDefinition) {
        super(worldKey, mapKey, backOnBounds, appContext, venue);
    }

    create() {
        super.create();

        setTimeout(() => {
            this.tutorialStep(TutorialPhase.MovingAround)
        }, 3)
    }

    tutorialStep(phase: TutorialPhase) {
        this.tutorialPhase = phase
        if (phase === TutorialPhase.MovingAround) {
            this.appContext.setGameOverlayMessage(new OverlayMessage("Moving Around",
                "Your character can move around the event space using the arrow keys. Try it out! Walk over to the sign.",
                TutorialPhase.MovingAround,
                () => {
                }))
        } else if (phase === TutorialPhase.Chatting) {
            this.appContext.setGameOverlayMessage(new OverlayMessage("Chatting", "Great! Now you're" +
                " going to learn how to talk to other people.",
                TutorialPhase.Chatting,
                () => this.showBot()))
        } /*else if (phase === TutorialPhase.TextChat) {
            this.appContext.setGameOverlayMessage(new OverlayMessage("Text Chat",
                "You will see other people walking around. You can see if they're typing, and if " +
                "you're close enough, you can see what they're saying. Walk over to our bot to hear messages.",
                null,
                ))
        }*/
    }

    showBot() {
        this.botPlayer = this.addOtherPlayer()

        const pai = new PlayerAndInfo(
            this.botPlayer.gamePlayer,
            // -20000,
            false,
            // false,
            new confappdata.Player(false, 0, 0, -20000),
            this.botPlayer.touchTyping,
            this.botPlayer.showTyping,
            this.botPlayer.hideTyping,
            () => "/assets/maps/tutorial/bot_head3.jpg"
        )

        let messageCount = 0

        this.time.addEvent({
            delay: 2000,                // ms
            callback: () => {
                this.botPlayer?.showTyping()
                let distance = Math.sqrt(
                    Math.pow(this.botPlayer?.gamePlayer.container.x! - this.gamePlayer!.container!.x, 2) +
                    Math.pow(this.botPlayer?.gamePlayer.container.y! - this.gamePlayer!.container!.y, 2))
                if (distance < 90) {
                    this.appContext.showMessage(
                        {
                            message: messageCount === 0 ? "Hi! I'm a bot!" : "I talk about bot stuff!",
                            messageKey: `message_${new Date().getTime()}`,
                            userId: -20000//"bot_head"
                        },
                        pai
                    )
                    messageCount++
                    if (messageCount > 1) {
                        this.time.removeAllEvents()
                        this.appContext.setGameOverlayMessage(new OverlayMessage("Send a message!",
                            "You can send messages to others near you. Click the comment entry box, or just start typing. " +
                            "Anybody inside the talk radius will get your message. Say something to the bot!",
                            null,
                            () => {
                                this.tutorialStep(TutorialPhase.ChatFunctionShow)
                                this.setupSendMessage()
                            }))
                    }
                }
            },
            //args: [],
            callbackScope: this,
            loop: true
        });

        this.botPlayer?.showTyping()
    }

    setupSendMessage = () => {
        this.appContext.setSendMessageCallback((message: string) => {
            const sentMessage = {
                messageKey: `mess_${new Date().getTime()}`,
                userId: this.appContext.currentUserId,
                message: message
            } as ChatMessage

            const playerInfo = new PlayerAndInfo(
                this.gamePlayer!,
                // this.appContext.currentUserId,
                true,
                // false,
                new confappdata.Player(false, 0, 0, this.appContext.currentUserId),
                () => {
                },
                () => {
                },
                () => {
                },
                () => `${process.env.REACT_APP_API_CALL}/image?id=${this.appContext.currentUserId}`
            )

            this.appContext.showMessage(sentMessage, playerInfo)

            if (this.appContext.isAudioActive()) {
                this.clunk!.play({
                    loop: false
                });
            }

            let distance = Math.sqrt(
                Math.pow(this.botPlayer?.gamePlayer.container.x! - this.gamePlayer!.container!.x, 2) +
                Math.pow(this.botPlayer?.gamePlayer.container.y! - this.gamePlayer!.container!.y, 2))

            if (distance < 90) {
                const pai = new PlayerAndInfo(
                    this.botPlayer!.gamePlayer,
                    // -20000,
                    false,
                    // false,
                    new confappdata.Player(false, 0, 0, -20000),
                    this.botPlayer!.touchTyping,
                    this.botPlayer!.showTyping,
                    this.botPlayer!.hideTyping,
                    () => "/assets/maps/tutorial/bot_head3.jpg"
                )

                setTimeout(() => {
                    this.appContext.showMessage(
                        {
                            message: `Hmm. '${message}'. Interesting...`,
                            messageKey: `message_reply_${new Date().getTime()}`,
                            userId: -20000
                        },
                        pai
                    )
                }, 1000)

                setTimeout(() => {
                    this.appContext.setGameOverlayMessage(new OverlayMessage("Show User Info",
                        "To see info about a user, click on their character image.",
                        null,
                        () => {
                            this.tutorialStep(TutorialPhase.UserProfile)
                        }))
                }, 2000)
            }
        })
    }

    processMapFeatures(map: Tilemap) {
        super.processMapFeatures(map);
        map.filterObjects("Objects", (obj) => {
            return obj.type === "TutorialSign"
        }).forEach((obj) => this.makeTutorialSign(obj as Phaser.GameObjects.Shape))
        const botSpot = map.filterObjects("Objects", (obj) => {
            return obj.type === "BotSpot"
        })[0] as Shape

        this.botX = botSpot.x
        this.boxY = botSpot.y

        const arrowPoint = map.filterObjects("Objects", (obj) => {
            return obj.type === "ArrowPoint"
        })[0] as Shape

        this.arrowX = arrowPoint.x
        this.arrowY = arrowPoint.y

        const wallGroup = this.physics.add.staticGroup()
        // playTable.cre

        const wallPoint = map.filterObjects("Objects", (obj) => {
            return obj.type === "WallPoint"
        })[0] as Shape

        wallGroup.create(wallPoint.x, wallPoint.y, "wall")


        setTimeout(() => {
            const collider = this.physics.add.collider(this.gamePlayer!.container, wallGroup!);
            this.wallParts = [wallGroup, collider]
        }, 1000)

    }

    makeTutorialSign(signBox: Phaser.GameObjects.Shape) {
        const sbBox = this.physics.add.staticSprite(signBox.x + (signBox.width / 2), signBox.y + (signBox.height / 2), "empty")
        sbBox.setSize(signBox.width, signBox.height);

        this.addCollide(sbBox, () => {
            this.tutorialStep(TutorialPhase.Chatting)
        })
    }

    playerMovement(x: number, y: number, flipX: boolean) {
        super.playerMovement(x, y, flipX);
        this.botPlayer?.touchTyping()
    }

    imTalkin = () => {
        // if (this.tutorialPhase > TutorialPhase.ChatFunctionShow) {
            this.gamePlayer!.talkRadius!.visible = true
            this.gamePlayer!.chatBubble.visible = true
            // this.sendTypingCallbacks.trigger()
        // }
    }

    imNotTalkin = () => {
        if (this.tutorialPhase > TutorialPhase.ChatFunctionShow) {
            this.gamePlayer!.talkRadius!.visible = false
            this.gamePlayer!.chatBubble!.visible = false
            // this.stompClient!.send("/app/doneTyping", this.worldKeyHeader(), "empty")
            // this.sendTypingCallbacks.clear()
        }
    }

    processMovement(containerBody: Phaser.Physics.Arcade.Body) {
        if (this.appContext.getGameOverlayMessage()) {
            this.gamePlayer!.player.anims.stop();
        } else {
            super.processMovement(containerBody);
        }
    }

    addOtherPlayer(): GamePlayerWithControls {
        let container = this.add.container(this.botX, this.boxY);
        container.setSize(32, 32);
        this.physics.world.enable(container);
        container.setDepth(3)

        container.on('pointerdown', function () {

        });

        const otherPlayer = this.add.sprite(0, 0, 'player', 9);
        otherPlayer.setDepth(3)
        container.add(otherPlayer)

        let chatBubble = this.add.sprite(2, -40, 'chatBubbles', 0)
        container.add(chatBubble)
        chatBubble.anims.play('talking', true);
        chatBubble.visible = false
        chatBubble.setDepth(1550)

        this.addHeadImage(container, chatBubble, "bot_head3", "/assets/maps/tutorial/bot_head3.jpg")

        const hideTyping = () => chatBubble.visible = false

        const touchTyping = () => {
            if (chatBubble.visible) {
                let distance = Math.sqrt(Math.pow(container.x - this.gamePlayer!.container!.x, 2) + Math.pow(container.y - this.gamePlayer!.container!.y, 2))
                if (distance < 90) {
                    chatBubble.alpha = 1
                } else {
                    chatBubble.alpha = .3
                }
            }
        }

        const showTyping = float(
            () => {
                chatBubble.visible = true
                touchTyping()
            }
            ,
            () => hideTyping(),
            5000
        )

        const gamePlayer = new GamePlayer(container, otherPlayer, null, chatBubble)
        return new GamePlayerWithControls(gamePlayer, touchTyping, showTyping, hideTyping)

    }

    showWorldArrows() {
        const arrowGroup = this.physics.add.staticGroup()
        // playTable.cre


        const arrows = [
            arrowGroup.create(this.arrowX, this.arrowY, "arrows") as Sprite,
            arrowGroup.create(this.arrowX, this.arrowY - 32, "arrows") as Sprite,
            arrowGroup.create(this.arrowX, this.arrowY - 64, "arrows") as Sprite,
        ]

        arrows.forEach((arrow) => arrow.setDepth(1))
        this.gamePlayer?.player.setDepth(2)
        this.gamePlayer?.chatBubble.setDepth(2)


        let arrowCount = 0
        this.time.addEvent({
            delay: 800,                // ms
            callback: () => {
                let loopCount = 0
                arrows.forEach((arrow) => arrow.visible = loopCount++ < arrowCount)
                arrowCount++
                if (arrowCount > arrows.length)
                    arrowCount = 0
            },
            //args: [],
            callbackScope: this,
            loop: true
        })
    }

    tutorialPause(block: () => void) {
        this.time.addEvent({
            delay: 800,                // ms
            callback: block,
            //args: [],
            callbackScope: this,
            loop: false
        })
    }

    addHeadImage(container: Phaser.GameObjects.Container, chatBubble: Phaser.GameObjects.Sprite, textureId: string, url: string) {
        // const playerTextureName = `bot_head`
        const addHead = () => {

            const icon = (this.add as any).rexCircleMaskImage(0, -20, textureId) as Sprite
            icon.setDepth(3)

            if (icon) {
                icon.width = 50
                icon.height = 50
                icon.setInteractive()
                icon.on('pointerdown', () => {
                    if (textureId === "bot_head3") {
                        const info = new PlayerProfileInfo("A Bot", "Bot Co", "I'm not a person!", "/assets/maps/tutorial/bot_head2.jpg")
                        this.appContext.showPlayerInfo(info, () => {
                            const [wallGroup, collider] = this.wallParts!
                            wallGroup!.children.entries.forEach((obj) => {
                                wallGroup!.remove(obj)
                                obj.destroy(true)
                            })
                            collider.destroy()
                            wallGroup!.destroy(true)
                            localStorage.setItem('tutorialDone', "true");
                            this.showWorldArrows()
                        })

                    }
                });
                container.add(icon)
                container.remove(chatBubble)
                container.add(chatBubble)
            }
        }

        if (this.textures.exists(textureId)) {
            addHead()
        } else {
            // let profileImage = "/assets/maps/tutorial/bot_head.jpg"
            const loader = this.load.image(textureId, url)
            loader.start()

            loader.on('filecomplete', function (key: string, file: any) {
                if (key === textureId) {
                    addHead()
                }
            }, this);
        }
    }
}
